'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconServer, iconServerTag } from '@ni/nimble-components/dist/esm/icons/server';
import { wrap } from '../../utilities/react-wrapper';

export type { IconServer };
export { iconServerTag };
export const NimbleIconServer = wrap(IconServer);